import { Stack } from "@mui/material";
import CustomQuillEditor from "components/quill/QuillEditor";
import { ExternalLinkIcon2, TextIcon } from "components";
import { Controller, useFormContext } from "react-hook-form";

import { useEffect } from "react";
import { ConfigItemsLayout } from "./ConfigItemsLayout";
import { extractStringFromHtml } from "utilz/helpers";
import { QuillEditorWithChips } from "components/quill";

export const TextConfigItem = (props: {
  options: any[];
  isLoading: boolean;
}) => {
  const { watch, setValue, control, formState } = useFormContext();

  return (
    <Stack gap={"16px"} position={"relative"}>
      <ConfigItemsLayout
        title="Text"
        description="Add sender attributes and other info like company name & website"
        icon={<TextIcon sx={{ width: 20, height: 20 }} />}
      >
        <></>
      </ConfigItemsLayout>
      <Controller
        control={control}
        name="signature_text"
        render={({ field }) => {
          return (
            <QuillEditorWithChips
              value={field.value}
              chipOptions={props.options}
              onChange={(value) => {
                const stringValue = extractStringFromHtml(value);
                if (field.value !== value) {
                  setValue(
                    "signature_text",
                    stringValue.length > 0 ? value : "",
                    {
                      shouldDirty: true,
                    },
                  );
                }
              }}
              readOnly={props.isLoading}
              pastingEnabled={false}
              keyboardEnabled={true}
              showToolbar={false}
              placeholder="Add signature content"
            />
          );
        }}
      />
    </Stack>
  );
};
